import Loadable from 'UIComponents/decorators/Loadable';
const AsyncContactsPriceBreakdownModal = Loadable({
  loader: () => import(
  /* webpackChunkName: "contact-price-breakdown-modal" */
  './ContactsPriceBreakdownModal'),
  LoadingComponent: () => null
});
export default AsyncContactsPriceBreakdownModal;